import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initMetrika, trackHit } from "./metrika";

// Boots the Yandex Metrica counter on first mount and logs a pageview on every
// client-side route change. The initial-pageview de-duplication lives in `trackHit`
// (module-level), so this stays correct even when the host layout remounts across the
// uz / ru route subtrees. The effects never run during SSG prerender (Node has no
// `window`), so the static HTML is untouched.
export function useMetrika(): void {
  const { pathname, search } = useLocation();

  useEffect(() => {
    initMetrika();
  }, []);

  useEffect(() => {
    trackHit(window.location.href);
  }, [pathname, search]);
}
